export enum RoleEnum {
  NATIONAL_ADMIN = 'NATIONAL_ADMIN',
  REGIONAL_ADMIN = 'REGIONAL_ADMIN',
  FOREST_ADMIN = 'FOREST_ADMIN',
  PERMIT_MANAGER = 'PERMIT_MANAGER',
  PERMIT_VIEWER = 'PERMIT_VIEWER',
  SUPPORT_USER = 'SUPPORT_USER',
}

export enum PrivilegeEnum {
  EDIT_USERS = 'EDIT_USERS',
  EDIT_PERMITS = 'EDIT_PERMITS',
  EDIT_SETTINGS = 'EDIT_SETTINGS'
}

export enum EmailTypeEnum {
  PERMIT_PURCHASE = 'PERMIT_PURCHASE',
  CONTACT_US = 'CONTACT_US',
  ERROR = 'ERROR'
}

export enum SettingsEnum {
  USER_MANAGEMENT = 'USER_MANAGEMENT',
  QA_USER_LOGIN =  'QA_USER_LOGIN',
  ENHANCED_PERMIT_COLUMN = 'ENHANCED_PERMIT_COLUMN',
  BYPASS_PERMIT_AVAILABILITY_CHECK = 'BYPASS_PERMIT_AVAILABILITY_CHECK',
}

export enum NodeEnvEnums {
  LOCAL = 'local',
  DEV = 'dev',
  PROD = 'production',
  QA = 'qa',
  STAGING = 'staging',
}
